import { render, staticRenderFns } from "./YakSwapPanel.vue?vue&type=template&id=194e1024&scoped=true&"
import script from "./YakSwapPanel.vue?vue&type=script&lang=js&"
export * from "./YakSwapPanel.vue?vue&type=script&lang=js&"
import style0 from "./YakSwapPanel.vue?vue&type=style&index=0&id=194e1024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e1024",
  null
  
)

export default component.exports